/**
 * Доступ приостановлен администратором (B-2376).
 *
 * Сюда уводит интерсептор `lib/api` на 403 `participant_blocked`: бэк закрывает
 * все ручки кабинета для заблокированного участника, и без отдельного экрана
 * каждая страница показала бы свою невнятную ошибку загрузки. Причину блокировки
 * участнику не показываем — это служебный комментарий админа.
 */

export function BlockedPage() {
  return (
    <main className="flex min-h-[100dvh] items-center justify-center px-4 py-10">
      <div className="w-full max-w-md text-center">
        <p className="mb-3 text-3xl">⏸️</p>
        <h1 className="mb-4 text-2xl font-semibold leading-tight text-slate-900 dark:text-slate-100 sm:text-3xl">
          Доступ приостановлен
        </h1>
        <p className="mb-8 text-base text-slate-600 dark:text-slate-300">
          Администратор акселератора временно закрыл доступ к кабинету. Прогресс и место в потоке
          сохранены. Если считаешь, что это ошибка, — напиши в поддержку DRAFTER.
        </p>
      </div>
    </main>
  );
}
